import {
  ICreateOrganizador,
  IListOrganizador,
} from "layouts/pages/cadatros/organizador/components/interfaces";
import api from "./api";

/**
 * Listar todos os organizadores
 */
export async function getAllOrganizador() {
  try {
    return await api.get("/organizador");
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Excluir uma organizadores
 */
export async function deleteOrganizador(id: number) {
  try {
    return await api.delete(`/organizador/${id}`);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Criar uma organização
 */
export async function saveOrganizador(organizador: ICreateOrganizador) {
  try {
    return await api.post<IListOrganizador>("/organizador", organizador);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Atualizar uma organizaçaõ
 */
export async function editOrganizador(organizador: ICreateOrganizador) {
  try {
    return await api.put(`/organizador/${organizador.id}`, organizador);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}
